/** Le temps d'observer une lecture saine avancer avant de conclure qu'elle est figée. */
export const LIVE_RESUME_PROGRESS_CHECK_MS = 1000;

/** Sur une seconde d'observation, une lecture saine avance d'environ une seconde. */
const MIN_PROGRESS_S = 0.25;

/** `HTMLMediaElement.HAVE_FUTURE_DATA` : en dessous, la lecture n'a pas de quoi avancer. */
const HAVE_FUTURE_DATA = 3;

export type LivePlaybackSnapshot = {
  readonly paused: boolean;
  readonly errored: boolean;
  readonly readyState: number;
};

/**
 * Au retour sur la page, ne recaler que si la lecture est réellement arrêtée. Une vidéo qui joue
 * n'a rien à rattraper : la ramener à `liveSyncPosition` la fait sauter et coupe le son, à chaque
 * clic sur l'onglet.
 */
export function needsLiveResync(playback: LivePlaybackSnapshot) {
  return playback.paused || playback.errored || playback.readyState < HAVE_FUTURE_DATA;
}

/** Lecture figée sans être en pause (MSE après un verrouillage mobile) : la position n'a pas bougé. */
export function isLivePlaybackStuck(startTimeS: number, endTimeS: number) {
  return endTimeS - startTimeS < MIN_PROGRESS_S;
}
